/*
|--------------------------------------------------------------------------
| Utilities: Pagination
|--------------------------------------------------------------------------
*/
/**
 * @namespace
 */
__gh__webApp.utilities.pagination = {

	"defaults": {
		"itemsPerPage": 10,
		"visiblePages": 5,
	},


	/**
	 * Get the settings for the pagination plugin
	 */
	"getSettings": function(options){

		var commonJS			= __gh__webApp.common,
			ghPagination		= __gh__webApp.utilities.pagination,
			paginationDefaults 	= ghPagination.defaults;

		// Options
		var paginationDOM 		= (options.paginationDOM) ? options.paginationDOM : null,
			startPageNumber 	= (options.start)		  ? options.start		  : 1,
			url					= (options.url)			  ? options.url			  : null,
			totalResults		= (options.totalResults)  ? options.totalResults  : null,
			itemsPerPage		= (options.itemsPerPage)  ? options.itemsPerPage  : paginationDefaults.itemsPerPage;
			visiblePages		= (options.visiblePages)  ? options.visiblePages  : paginationDefaults.visiblePages;


		var totalPages			= (totalResults > itemsPerPage) ? commonJS.divideAndRound(totalResults,itemsPerPage) : 1,
			loadContentData		= {
				"paginationDOM"	: paginationDOM,
				"start"			: startPageNumber,
				"url"			: url,
				"totalResults"	: totalResults
			};

		return {
			"startPage"					: startPageNumber,
			"initiateStartPageClick"	: false,
			"totalPages"				: totalPages,
			"visiblePages"				: visiblePages,
	        "onPageClick"				: function (event, pageNumber) {
				//Update starting page number
				loadContentData.start 	= pageNumber;
				loadContentData.url	 	= ghPagination.changeURLPageNumber({
				   "url"			: url,
				   "start"			: pageNumber,
				   "paginationDOM"	: paginationDOM
				});
				loadContentData._index = History.getCurrentIndex();

				//Save to history API
				historyApiURL = commonJS.updateURLParams({
					"params":{"start":pageNumber}
				}),
				pageTitle = commonJS.getPageTitleWithPageNumber({"pageNumber":pageNumber});

				History.replaceState(loadContentData, pageTitle, historyApiURL);

				ghPagination.pageChangeCallbacks(event,pageNumber,paginationDOM);

	        }
	    }

	},


	/**
	 * Callback functions to run when the page changes
	 */
	"pageChangeCallbacks": function(event,pageNumber,paginationDOM){
		var commonJS		= __gh__webApp.common,
			currentPage 	= __gh__webApp.currentPage,
			trackPagination	= __gh__webApp.utilities.tracker.trackPagination,
			pageTitle  		= commonJS.getPageTitleWithPageNumber({"pageNumber":pageNumber});
			
		//insert callback functions here.
		if(paginationDOM === '#gh-pagination-search') {
			try{
			__gh__webApp.ads.search.loadSearchAds(__gh__coreData.globalVariables.ads.keywords,pageNumber); //refresh ad sense ads
			googletag.pubads().refresh(); //Call to refresh DFP Ads
			}
			catch(e){
				///error on refresh
			}
		}
		
		if(currentPage.isSearch()){
			__gh__webApp.searchPage.pagination.callbacks(pageNumber);
			return;
		}
		
		trackPagination({"title":pageTitle});
		

	},


	/**
	 * Load search content
	 * @param {object} options
	 * @param {integer} [options.start=1] - page to start on
	 * @param {string} options.url - url to use to get new content
	 * @param {string} options.paginationDOM - the dom selector for the pagination
	 */
	"loadContent": function(options){
		var start 			= (options.start)			? options.start			: 1,
			url				= (options.url)				? options.url 			: null,
			paginationDOM	= (options.paginationDOM)	? options.paginationDOM	: null;

		//Get values from data attributes
		var $pagination 				= $(paginationDOM),
			view						= $pagination.data("gh-pagination-view"),
			contentDOM					= $pagination.data("gh-pagination-content-dom"),
			scrollToTopDOM				= $pagination.data("gh-pagination-scroll-to-top-dom"),
			scrollToTopDOM				= (scrollToTopDOM) ? scrollToTopDOM : contentDOM;

		//Load JSON
		var items			= __gh__webApp.utilities.fetch.json.get({"url": url});
		if(!items){return;}

		//Prep view data
		var viewData		= {
				"items" : items,
				"view"	: view
		};

		$("html, body").animate({ "scrollTop": 0}, "fast");

		//Append view to DOM
		__gh__webApp.utilities.fetch.handlebarsView.replace({
			"data": viewData,
			"dom" : contentDOM,
			"view": view
		});

		//Update total results
		if(items.hasOwnProperty("total")){
			$pagination.data("gh-pagination-total-results",items.total);
		}

		this.triggerPostLaydownFunctions();
		$(contentDOM).fadeIn("slow");


	},


	/**
	 * Load new content
	 * This calls load content, but updates the page number and saves the history info as well
	 * Used this because first page is laid down
	 * @param {object} options
	 * @param {integer} [options.start=1] - page to start on
	 * @param {string} options.url - url to use to get new content
	 * @param {string} options.paginationDOM - the dom selector for the pagination
	 */
	"loadNewContent": function(options){
		var startPageNumber = (options.start)			? options.start			: null,
			url				= (options.url)				? options.url 			: null,
			paginationDOM	= (options.paginationDOM)	? options.paginationDOM	: null,
			commonJS		= __gh__webApp.common;

		//Load content
		var loadContentData = {
		       "start"			: startPageNumber,
		       "url"			: url,
		       "paginationDOM" 	: paginationDOM
		};
		//this.changeActivePageNumber(loadContentData);
		this.loadContent(loadContentData);
	},


	"changeActivePageNumber": function(options){
		var newPageNumber 			= (options.start) ? options.start : null; // starts at 0
			paginationDOM 			= (options.paginationDOM) ? options.paginationDOM 	: null;

			if($(paginationDOM).data("twbsPagination")){
				$(paginationDOM).twbsPagination('show',newPageNumber);
			}
	},


	"changeURLPageNumber": function(options){
		var url 					= (options.url) 			? options.url 			: null,
			paginationDOM			= (options.paginationDOM) 	? options.paginationDOM : null,
			pageNumber				= (options.start)			? options.start			: null,
			commonJS				= __gh__webApp.common,
			url;

		//Update URL
		url =  commonJS.updateURLParams({
			"url"		: url,
			"params"	: {"start":pageNumber}
		});

		//Update url data attribute
		$(paginationDOM).attr("data-gh-pagination-url",url);
		return url;
	},


	"rebuildPagination": function(options){

		var ghPagination = __gh__webApp.utilities.pagination;

		// Options
		var options = {
			"paginationDOM"	: 	(options.paginationDOM) ? options.paginationDOM : null,
			"start"			:	(options.start)		  	? options.start		  	: null,
			"url"			:	(options.url)			? options.url			: null,
			"totalResults"	:	(options.totalResults)  ? options.totalResults  : null
		},
		settings = ghPagination.getSettings(options);

		// Rebuild pagination
		$pagination	= $(options.paginationDOM);
		$pagination.twbsPagination('destroy');
		if(settings.totalPages > 1){$pagination.show();}else{$pagination.hide();}
		$pagination.twbsPagination(settings);
	},


	"loadPagination": function() {
        var ghPagination 	= this,
        	commonJS		= __gh__webApp.common;

        $("[data-gh-pagination-loaded=false]").each(function(){
			var $pagination  				= $(this),
				totalResults				= $pagination.data("gh-pagination-total-results");

			//Only load each pagination dom once.
			if(!$pagination.data("gh-pagination-loaded")){
				$pagination.attr("data-gh-pagination-loaded",true);

				//Set up variables
				var loadContentData = {
				       "start"			: $pagination.data("gh-pagination-current-page"),
				       "contentDOM"		: $pagination.data("gh-pagination-content-dom"),
				       "view"			: $pagination.data("gh-pagination-view"),
				       "url"			: $pagination.data("gh-pagination-url"),
				       "paginationDOM" 	: $pagination.data("gh-pagination-dom"),
				       "_index"			: History.getCurrentIndex(),
				       "totalResults"	: totalResults,
					},
					startPageNumber		= loadContentData.start,
					url					= loadContentData.url,
					historyApiURL 		= commonJS.updateURLParams({
						"params": {"start":startPageNumber}
					}),
					pageTitle = commonJS.getPageTitleWithPageNumber({"pageNumber":startPageNumber});

				//Load history for the first page since that was done through the bucket laydown
				History.replaceState(loadContentData, pageTitle, historyApiURL);


				//Initialize pagination if there is more than one page
				var settings = ghPagination.getSettings(loadContentData);
				if(settings.totalPages > 1){$pagination.show();}else{$pagination.hide();}
				$pagination.twbsPagination(settings);

			}

	  	});

    },


    "triggerPostLaydownFunctions": function(){
	    //Images
	    __gh__webApp.utilities.lazyImages.loadAllImages();
	}
};
